var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProofreadTranslationLoading = function SvgIconProofreadTranslationLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_proofread_translation_loading_svg__a)",
    d: "M6.666.018c.296-.044.598.03.84.208a1.15 1.15 0 0 1 .265 1.588 1.14 1.14 0 0 1-.726.472 5.7 5.7 0 0 0-3.41 1.959 5.77 5.77 0 0 0-1.35 3.71c0 1.525.603 2.988 1.674 4.066A5.7 5.7 0 0 0 8 13.705v2.3c-4.418 0-8-3.603-8-8.05C0 4.011 2.839.665 6.666.018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_proofread_translation_loading_svg__b)",
    d: "M11.727 2.052a1.14 1.14 0 0 1 1.23-.317q.216.076.385.23a8 8 0 0 1 1.965 2.71A8.1 8.1 0 0 1 16 7.956c0 4.447-3.582 8.05-8 8.05v-2.3a5.7 5.7 0 0 0 3.24-1.013 5.74 5.74 0 0 0 2.097-2.682 5.8 5.8 0 0 0 .217-3.405 5.76 5.76 0 0 0-1.74-2.93 1.15 1.15 0 0 1-.087-1.624"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_proofread_translation_loading_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 515.435 -512.295 0 408 735.579)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4276EE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4276EE",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_proofread_translation_loading_svg__a",
    x1: 400,
    x2: 400,
    y1: 84.335,
    y2: 1468.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4276EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4276EE",
    stopOpacity: 0.55
  })))));
};
export default SvgIconProofreadTranslationLoading;